import React, { useContext, useEffect, useState } from 'react';
import UserContext from '../../contexts/UserContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import authenticate from '../../utils/Authenticate';
import { setActiveZoneId, getActiveZoneId } from '../../utils/zoneSession';
import displayError from '../../utils/ErrorHandler';


const Home = () => {
  const { user,setUser } = useContext(UserContext);
  const [requests, setRequests] = useState([]);
  const [message,setMessage] = useState('')

  const navigate = useNavigate();

  const requestPage = () => {
    /*if(user?.zone?.desc.toLowerCase().includes("mamur"))
    {
      navigate("/zc/create-items-request");
    }else{
      navigate("/zc/create-request");
    }*/
    navigate("/zc/create-items-request");
  };

  const getRequests = async () => {
    console.log("IN GETTING ZONES");
    console.log(user);
    const zoneId = user?.zone?._id || getActiveZoneId();
    if (user?.zone?._id) setActiveZoneId(user.zone._id);
    if (!zoneId) return; // wait until zone known
    await axios.get(`${process.env.REACT_APP_API_URI}/api/request/get?id=${zoneId}`, { withCredentials: true }).then((response) => {
      console.log(response);
      if (response.data.success) {
        setRequests(response?.data?.data);
      }
    }).catch((err) => {
      const errorMessage = displayError(err,navigate,setUser);
      console.log(errorMessage);
        if(errorMessage){
          setMessage(errorMessage)
        }
    })
  };

  useEffect( () => {
    async function startup(){
      if(!user){
        await authenticate(setUser,navigate);
      }
      if(user){
        getRequests();
      }
    }
    startup();
  },[user])

  const getStatusClasses = (status) => {
    switch (status) {
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'approved':
        return 'bg-green-100 text-green-800';
      case 'rejected':
        return 'bg-red-100 text-red-800';
      case 'dispatched':
        return 'bg-blue-100 text-blue-800';
      case 'received':
          return 'bg-green-100 text-green-800';
      case 'Items Received':
        return 'bg-green-500 text-white';
      case 'supplyapproved':
        return 'bg-teal-100 text-teal-800';
      case 'In Process':
        return 'bg-orange-100 text-orange-800';
      default:
        return 'bg-orange-100 text-orange-800';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
    return new Intl.DateTimeFormat('en-GB', options).format(date);
  };

  return (
    <>
      <div className="w-full px-4">
      {message?
        <div class="bg-red-100 border border-red-300 text-red-500 px-4 py-3 mx-0 rounded relative" role="alert">
          <span class="block sm:inline">{message}</span>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3">
          </span>
        </div>
        :null}
        {requests && requests.length > 0 ? (
          requests.map((request, i) => (
            <div
              key={request._id}
              onClick={() => navigate("request", { state: { request, index: i } })}
              className="flex flex-row justify-between items-center bg-white rounded-lg shadow-md mt-2 p-4 border border-gray-200 hover:shadow-lg transition-shadow duration-300 cursor-pointer w-full"
            >
              <div className="flex flex-col">
                {request.menu ? (
                  <div className='flex-grow'>
                    <p className="font-semibold text-[16px] text-fmb flex-grow py-1">REQ #00{i + 1}</p>
                    <h4 className="text-sm text-amber-700 text-[18px] font-semibold flex-grow pb-2">{request.menu.name}</h4>
                  </div>
                  ) : (<h4 className="text-sm text-amber-700 text-[18px] font-semibold text-center flex-grow pb-2">REQ #00{i + 1}</h4>)}
                <span className="text-gray-500 text-sm">{formatDate(request.createdAt)}</span>
              </div>
              <div className="flex flex-row items-center">
                <span className={`text-sm font-semibold mr-2 px-3 py-1 rounded-full ${getStatusClasses(request.status)}`}>
                  {request.status}
                </span>
                <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                </svg>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center mt-10">
            <h6 className="text-gray-600">No Requests Found!</h6>
          </div>
        )}

        <div className="fab-container" onClick={requestPage}>
          <button className="fab-button bg-fmb">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
          </button>
          <span className="fab-text text-fmb">Add New Request</span>
        </div>
      </div>
    </>
  );
};

export default Home;
